import { AppSettings } from "../../managers/AppSettings";
import { LayoutDataManager } from "../../managers/LayoutDataManager";
import { OptionsLeafPopupContentBase } from "./OptionsLeafPopupContentBase";


/**
 * Content of popup containing paragraph of text
 */
export class OptionsLeafPopupTextContent
    extends OptionsLeafPopupContentBase
{
    public txtBody: Phaser.GameObjects.Text;

    
    public override Build(): void
    {
        // > bg
        super.Build();

        // this.name = "OptionsLeafPopupTextContent";

        this.txtBody = this.scene.make.text({
            style: {
                color: "#fff",
                align: "left",
                fontFamily: AppSettings.fontFamilies.MontserratBold,
                lineSpacing: LayoutDataManager.GetSharedData().options.leafPopup.helpContent.body.lineSpacing,
            }
        });
        this.txtBody.setData("baseFontSize", 60);
        this.txtBody.setOrigin(0);
        this.content.add(this.txtBody);
    }
    
    /**
     * Data has been set. 
     * Update view.
     */
    public override UpdateFromData(setHelpText: boolean = false): void
    {
        // console.log("UpdateFromData");

        // > title
        super.UpdateFromData(setHelpText);

        if (setHelpText) {
            this.txtBody.text = this.itemLocData.help;
            // console.log(this.itemLocData.help);
        }
    }

    public override SetInnerScale(innerScale: number): void
    {
        // > title
        super.SetInnerScale(innerScale);

        // NOTE: setting scale on TF messes up wordWrap, so we scale fontSize instead
        this.txtBody.setFontSize(this.txtBody.getData("baseFontSize") * innerScale);
    }

    /**
     * @alike: @see OnResize
     * 
     * NOTE: Content is bottom-right aligned
     * @param size 
     */
    public override SetSize(width: number, height: number): void
    {
        // console.log("SetSize",size);

        // NOTE: only sets width
        // > bg black A80 overlay (spans whole size)
        super.SetSize(width, height);
        const overlayWidth = width - this.borderPadding.left - this.borderPadding.right;
        const overlayHeight = height - this.borderPadding.top - this.titlePadding.top - this.btnBack.label.displayHeight * this.btnBack.scaleY - this.titlePadding.bottom - this.borderPadding.bottom;

        this.txtBody.style.setWordWrapWidth(this.size.width - this.borderPadding.left - this.borderPadding.right);
        
        // additionally set height (for overflow scrolling)
        this.content.GetSize().height = this.txtBody.displayHeight;
        
        this.contentMask.SetMaskRectSize(overlayWidth, overlayHeight);
        this.UpdateInPlace();
    }
}